if(window.location.href.includes('/cart')){

  setTimeout(()=>{
             document.querySelectorAll(".product-option dt").forEach((z)=>{
    console.log(z.innerHTML);
  if(z.innerHTML=='id: '){
      z.parentElement.style="visibility:hidden";
  }  
    if(z.innerHTML=='Fee: '){
      z.parentElement.style="visibility:hidden";
  }    
   
})
  //fixing displayfee
  $('.pfandfee p').each(function() {
    // get element text
    var text = $(this).text();
    // modify text
    text = text.replace('Einweg-/Mehrwegpfand zu', 'Pfand für');
    text = text.replace(')"', ' Flaschen)');
    // update element text
    $(this).text(text); 
});
             },2100)
}